export enum PartnerNamesEnum {
    //Antrag Partner
    ADREX = 'adrex',
    AVEXTRA = 'avextra',
    BETAHEALTH = 'betahealth',
    ALTHEA = 'althea',
    SWISS = 'ch',
    FOUR_20_PHARMA = 'four_20_pharma',

    //Titration Partner
    DOSIS_EQ_DEMO = 'dosis_eq_demo',
    DOSIS_EQ_TILRAY = 'dosis_eq_tilray',
    DOSIS_EQ_HORMOSAN = 'dosis_eq_hormosan',
    DOSIS_EQ_420_PHARMA = 'dosis_eq_420_pharma'
}

export const ParterEnumForValue = (value: string) => {
    return Object.keys(PartnerNamesEnum).find(a => PartnerNamesEnum[a] === value);
}

export const showQuestionForPartner = (quest: CannabisQuestion, partnerName: any) => {
    if (!quest.displayForPartners || quest.displayForPartners.indexOf(partnerName) > -1) {
        if (!quest.hideForPartners || quest.hideForPartners.indexOf(partnerName) === -1) {
            return true;
        }
    }
    return false;
}


export class ResearchCard {
    id: string;
    title?: string;
    title_de?: string;
    date?: string;
    url?: string;
    abstract?: string;
    chemicals?: string[];
    keywords?: string[];
    mesh_terms?: string[];
    publication_types?: any[];
    tags?: ResearchCardTab[];
}

class ResearchCardTab {
    text: string;
    popup: string;
}

export enum ValueTypeEnum {
    INPUT = 'INPUT',
    TEXTAREA = 'TEXTAREA',
    SELECT = 'SELECT',
    FILTER_SELECT = 'FILTER_SELECT',
    DATE = 'DATE',
    OPTION = 'OPTION',
    OPTIONS = 'OPTIONS',
    LIST = 'LIST',
    CARDS = 'CARDS',
    PERSCRIPTIONS = 'PERSCRIPTIONS',
    INHALATIV_ORAL = 'INHALATIV_ORAL',
    THC_CBD_GROUP = 'THC_CBD_GROUP',
    TITRATIONSPLAN = 'TITRATIONSPLAN'
}

export enum QuestionTypeEnum {
    NUMBER = 'NUMBER',
    EXPAND = 'EXPAND',
    IMAGE = 'IMAGE'
}

export enum WidthTypeEnum {
    FULL = 'FULL',
    HALF = 'HALF'
}

export class Perscriptions {
    product?: string;
    dosage?: string;
    usedFor?: CannabisOption[];
    value?: string;
}

export class CannabisOption {
    Label: string;
    Code?: string;
    Selected?: boolean;
    Tooltip?: string;
}

export class CannabisOptionNested extends CannabisOption {
    options?: CannabisOptionNested[];
}

export class CannabisOptionAnswer {
    Label: string;
    Code?: string;
}

export class THC_CBD_Mapping {
    Code: string;
    MapTo: number[];
}

export class THC_CBD_Value {
    Value: number;
    Equality?: string;
    Min?: number;
    Max?: number;
}

export class THC_CBD_Group {
    No: number;
    Title: string;
    THC: THC_CBD_Value;
    CBD: THC_CBD_Value;
}

export class MedikamenteTable {
    Name: string;
    Wirkstoffmenge: string;
    Unit: string;
    Applikation: string;
    Single: boolean;
    Dosierung: string;
    Morgen: string;
    Mittag: string;
    Abend: string;
    Nacht: string;
    InputValue: string;
}

export class Titrationsplan {
    dronabinolSorte: any;
    zieltagesdosis: any;
    startTagesdosis: any;
    anzahlDerTage: any;
    morgens: any;
    mittags: any;
    abends: any;
    zurNacht: any;
}

export class CannabisAnswer {
    selected?: boolean;
    inputValue?: string;
    freeTextInputValue?: string;
    option?: CannabisOptionAnswer;
    options?: CannabisOptionAnswer[];
    rangeValue?: number;
    cards?: ResearchCard[];
    perscriptions?: Perscriptions[];
    thcCbdGroup?: THC_CBD_Group;
    medikamenteTable?: MedikamenteTable[];
    titrationsplan?: Titrationsplan;
}

export class CannabisQuestion {
    displayForPartners?: PartnerNamesEnum[];
    hideForPartners?: PartnerNamesEnum[];
    questionNumber: number;
    displayNumber?: number;
    question: string;
    questionDesc?: string;
    questionType?: QuestionTypeEnum;
    questionInfo?: string;
    image?: string;
    expanded?: boolean;
    stepper?: string;
    questions?: CannabisQuestion[];
    valueType?: ValueTypeEnum;
    widthType?: WidthTypeEnum;
    hideBorder?: boolean;
    extraInput?: string;
    freeTextInput?: string;
    placeholder?: string;
    showEditor?: string;
    options?: CannabisOption[];
    hideAnswer?: boolean;
    answer?: CannabisAnswer;
    hasDynamicOptions?: boolean;
    dynamicOptions?: CannabisOption[];
    showLoading?: boolean;
    buttonText?: string;

    groupBy?: string;
    orderBy?: string;
    showFilter?: boolean;
    fuzzyFilter?: boolean;
    filterText?: string;
}

export class CannabisSection {
    expanded: boolean;
    title: string;
    sectionNumber: number;
    questions: CannabisQuestion[];
}

export class THC_CBD_MODEL {
    THC: number;
    CBD: number;
}

export class CenterRadius {
    Option: string;
    Center: THC_CBD_MODEL;
    Radius: THC_CBD_MODEL;
}

export class FifteenOption {
    Kasse: string;
    Strasse: string;
    PLZ: string;
    Ort: string;
}
